import MatchType from "./MatchType";

const COMPANYNAME = ['', '', 'BET365', '皇冠', '10BET', '立博', '明陞', '澳彩', 'SNAI', '威廉希尔', '易胜博', '韦德', 'EuroBet', 'Inter wetten', '12bet', '利记', '盈禾', '18Bet', 'Fun88', '竞彩官方', '', '188', '平博'];

export default class IndexData {
    constructor() {
        this.company_id = 0;
        this.initIdex = null;
        this.realTime = null;
    }

    getName() {
        return COMPANYNAME[this.company_id] ? COMPANYNAME[this.company_id] : '';
    }

    getInitAsia(i) {
        if (this.initIdex) {
            return this.initIdex.getasia(i);
        }
        return '';
    }

    getRealTimeAsia(i) {
        if (this.realTime) {
            return this.realTime.getasia(i);
        }
        return '';
    }

    getInitEu(i) {
        if (this.initIdex) {
            return this.initIdex.geteu(i);
        }
        return '';
    }

    getRealEu(i) {
        if (this.realTime) {
            return this.realTime.geteu(i);
        }
        return '';
    }

    getInitResult(matchType) {
        if (this.initIdex) {
            return this.initIdex.getResult(matchType);
        }
        return '';
    }

    getRealResult(matchType) {
        if (this.realTime) {
            return this.realTime.getResult(matchType);
        }
        return '';
    }

    getInitBs(i) {
        if (this.initIdex) {
            return this.initIdex.getbs(i);
        }
        return '';
    }

    getRealBs(i) {
        if (this.realTime) {
            return this.realTime.getbs(i);
        }
        return '';
    }

}
